// extracted by mini-css-extract-plugin
export default {"overlay":"overlay--ujoqsgxNi0azw1p"};